import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * DataUpdater serves as an intermediate component to receive the data
 * and save it to the context. It actually renders nothing and no other
 * actions it's taken apart from updating the context.
 */

class DataUpdater extends Component {
	state = {};

	static propTypes = {
		updater: PropTypes.func.isRequired,
		dataName: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.arrayOf(PropTypes.string),
		]),
	};

	/**
	 * getDerivedStateFromProps is run before any render, but in the case
	 * of this component, as it doesn't have any state changes, the only reason
	 * that renders are triggered are new props coming. The fact that its direct
	 * parent is a PureComponent allows us to sure that the renders are triggered
	 * when actually needed.
	 *
	 * Now, we take advantage of this lifecycle being here the place where the state
	 * can be updated (the context state) as it can't be done in the render.
	 */

	static getDerivedStateFromProps = ({
		updater,
		dataName,
		data,
		...queryResult
	}) => {
		const newContextValue = {};

		if (Array.isArray(dataName)) {
			dataName.forEach(name => {
				newContextValue[name] = {
					...data,
					...queryResult,
				};
			});
		} else {
			newContextValue[dataName] = {
				...data,
				...queryResult,
			};
		}

		updater(newContextValue);
		// Make sure to return null, this won't trigger any rerender.
		return null;
	};

	render() {
		return <noscript />;
	}
}

export default DataUpdater;
